import React, { useRef, useState, useEffect, useMemo } from "react";
import * as Icons from "react-feather";
import { useClickDetecter } from "lib/helpers";

export default function Modal(props) {
  const [selectedSection, setSelectedSection] = useState("title");
  const [indicatorStyle, setIndicatorStyle] = useState({});
  const wrapperRef = useRef(null);
  const containerRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const listSelector = [
    { en: "title", name: "بخش عنوان ها" },
    { en: "category", name: "بخش دسته بندی" },
    { en: "description", name: "بخش توضیحات" },
    { en: "playr", name: "بخش بازیکن ها" },
    { en: "media", name: "بخش مدیا" },
  ];

  const handleClick = (event, englishTitle) => {
    if (!containerRef.current) return;
    setSelectedSection(englishTitle);

    const target = event.target;
    const rect = target.getBoundingClientRect();
    const containerRect = containerRef.current.getBoundingClientRect();

    const scrollLeft = containerRef.current.scrollLeft;

    setIndicatorStyle({
      width: rect.width,
      height: rect.height,
      left: rect.left - containerRect.left + scrollLeft,
      top: rect.top - containerRect.top,
    });
  };

  const handleNext = () => {
    const currentIndex = listSelector.findIndex(
      (item) => item.en === selectedSection
    );
    const nextIndex = currentIndex + 1;

    if (nextIndex < listSelector.length) {
      setSelectedSection(listSelector[nextIndex].en);

      setTimeout(() => {
        const target = containerRef.current.children[nextIndex];
        if (!target) return;

        const rect = target.getBoundingClientRect();
        const containerRect = containerRef.current.getBoundingClientRect();
        const scrollLeft = containerRef.current.scrollLeft;

        setIndicatorStyle({
          width: rect.width,
          height: rect.height,
          left: rect.left - containerRect.left + scrollLeft,
          top: rect.top - containerRect.top,
        });
      }, 0);
    }
  };

  const handlePrev = () => {
    const currentIndex = listSelector.findIndex(
      (item) => item.en === selectedSection
    );
    const prevIndex = currentIndex - 1;

    if (prevIndex >= 0) {
      setSelectedSection(listSelector[prevIndex].en);

      setTimeout(() => {
        const target = containerRef.current.children[prevIndex];
        if (!target) return;

        const rect = target.getBoundingClientRect();
        const containerRect = containerRef.current.getBoundingClientRect();
        const scrollLeft = containerRef.current.scrollLeft;

        setIndicatorStyle({
          width: rect.width,
          height: rect.height,
          left: rect.left - containerRect.left + scrollLeft,
          top: rect.top - containerRect.top,
        });
      }, 0);
    }
  };

  const hasSection = React.Children.toArray(props.children).some(
    (child) => React.isValidElement(child) && child.props["data-section"]
  );

  const renderedTabs = useMemo(() => {
    return listSelector.map((item, index) => (
      <div
        key={`item_${index}`}
        className={`p-2 cursor-pointer text-[13px] text-center min-w-[133px] md:min-w-[120px] z-10 ${
          selectedSection === item.en
            ? "text-black font-bold"
            : "text-white font-normal"
        }`}
        onClick={(e) => handleClick(e, item.en)}
      >
        {item?.name}
      </div>
    ));
  }, [selectedSection]);

  useClickDetecter(wrapperRef, (flag) => {
    if (flag == false) {
      // props.handleClose();
    }
  });

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!props.show) {
    return null;
  }

  const currentIndex = listSelector.findIndex(
    (item) => item.en === selectedSection
  );
  const isLastTab = currentIndex === listSelector.length - 1;
  const isFirstTab = currentIndex === 0;

  return (
    <>
      <div
        id="header-footer-modal-preview "
        style={{
          zIndex: props.zIndex ?? 999,
        }}
        className={`fixed inset-0 z-[${props.zIndex ?? 999}] ${
          props.show ? "block" : "hidden"
        }`}
      >
        <div className="fixed inset-0 bg-black/50"></div>

        <div
          className={`relative mx-auto ${
            props.size === "lg"
              ? "max-w-7xl"
              : props.size === "sm"
              ? "max-w-md"
              : "max-w-4xl"
          } w-full sm:w-auto sm:min-w-[600px]`}
          style={{
            height: "auto",
            maxHeight: "calc(100vh - 2rem)",
            margin: "1rem auto",
            top: window.innerWidth < 640 ? "0" : "50%",
            transform: window.innerWidth < 640 ? "none" : "translateY(-50%)",
          }}
          ref={wrapperRef}
        >
          <div
            className={`relative 
                        bg-white 
                        rounded-lg 
                        shadow-xl 
                        flex flex-col 
                        max-h-[90vh] 
                        md:max-h-[calc(100vh-4rem)]`}
          >
            {/* Header */}
            <div className="modal-header flex justify-between">
              <h2 className="font-medium text-base">{props.title}</h2>
              <button
                type="button"
                onClick={props.handleClose}
                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg p-1.5 mr-auto inline-flex items-center"
              >
                <Icons.X className="w-5 h-5" />
              </button>
            </div>

            {/* Tabs Section */}
            {hasSection && (
              <div
                className="flex gap-5 p-5 bg-[#1c3faa] relative overflow-x-auto"
                ref={containerRef}
              >
                {renderedTabs}
                <i
                  className="bg-white/30 block absolute rounded-lg transition-all duration-300"
                  style={{
                    width: `${indicatorStyle.width}px`,
                    height: `${indicatorStyle.height}px`,
                    left: `${indicatorStyle.left}px`,
                    top: `${indicatorStyle.top}px`,
                  }}
                ></i>
              </div>
            )}

            {/* Body */}
            <div
              className={`p-4 
                          md:p-6 
                          overflow-y-auto 
                          max-h-[80vh] 
                          md:max-h-[calc(100vh-10rem)]`}
            >
              {React.Children.map(props.children, (child) => {
                if (!React.isValidElement(child)) return null;
                const section = child.props["data-section"];
                if (!section) return child;
                if (section === selectedSection) {
                  return React.cloneElement(child, { key: selectedSection });
                }
                return null;
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
